module.exports = __webpack_public_path__ + "img/5b33a97.png";